import type { ProposalDeadlineRadarItem } from "@tc/shared";

const API_URL = import.meta.env.VITE_API_URL ?? "/api";

/** Calendar data (TW-3456). Trips come from `tripsApi.list`; this is the pending-deadline feed. */
export const calendarApi = {
  /**
   * The caller's still-pending proposal deadlines to plot (RLS-scoped: a club user sees only its
   * own club, back office sees all). Back office may narrow to one club via `?clubId=` — the topbar
   * switcher; the filter is ignored for club users.
   */
  deadlines: async (clubId?: string): Promise<ProposalDeadlineRadarItem[]> => {
    const qs = clubId ? `?clubId=${encodeURIComponent(clubId)}` : "";
    const res = await fetch(`${API_URL}/proposals/calendar-deadlines${qs}`, {
      headers: { accept: "application/json" },
    });
    if (!res.ok) throw new Error(`Request failed (${res.status})`);
    return (await res.json()) as ProposalDeadlineRadarItem[];
  },
};
